<template>
  <div>
    <form class="flow-form-cum-panel w3-col">
      <!-- name part -->
      <div class="w3-container flow-padding-top">
        <p class="w3-col w-80pc flow-form-inline-input">
          <label class="w3-left flow-blue-color flow-padding-bottom">{{
            $t("name")
          }}</label>
          <input
            class="w3-input"
            v-bind:class="errors.nameError ? 'error' : ''"
            type="text"
            v-bind:placeholder="$t('name')"
            v-model="access.name"
            @blur="validateName"
          />
          <span class="w3-text-red"> {{ errors.nameError }} </span>
        </p>
      </div>
      <!-- contact part -->
      <div class="w3-container flow-padding-top">
        <p class="w3-col w-80pc flow-form-inline-input">
          <label class="w3-left flow-blue-color flow-padding-bottom">{{
            $t("contact")
          }}</label>
          <input
            class="w3-input"
            v-bind:class="errors.contactError ? 'error' : ''"
            type="text"
            v-bind:placeholder="$t('contact')"
            v-model="access.contact"
          />
          <span class="w3-text-red"> {{ errors.contactError }} </span>
        </p>
      </div>
      <!-- access duration part -->
      <div class="w3-container flow-padding-top">
        <p class="w3-col w-80pc flow-form-inline-input">
          <label class="w3-left flow-blue-color flow-padding-bottom">{{
            $t("from")
          }}</label>
          <input
            class="w3-input"
            v-bind:class="errors.startError ? 'error' : ''"
            type="text"
            v-bind:placeholder="$t('dd-mm-yyyy')"
            v-model="access.start"
            @blur="validateStartDate"
          />
          <span class="w3-text-red"> {{ errors.startError }} </span>
          <br v-if="errors.startError" />
          <label class="w3-margin-top w3-left flow-blue-color flow-padding-bottom">{{
            $t("until")
          }}</label>
          <input
            class="w3-input"
            v-bind:class="errors.endError ? 'error' : ''"
            type="text"
            v-bind:placeholder="$t('dd-mm-yyyy')"
            v-model="access.end"
            @blur="validateEndDate"
          />
          <span class="w3-text-red"> {{ errors.endError }} </span>
        </p>
      </div>

      <!-- patient id part -->
      <div class="w3-container flow-padding-top">
        <p class="w3-col w-80pc flow-form-inline-input">
          <label class="w3-left flow-blue-color flow-padding-bottom">{{
            $t("patientId")
          }}</label>
          <input class="w3-input" v-model="access.patientId" disabled />
        </p>
      </div>

      <!-- contact email part -->
      <div class="w3-container flow-padding-top">
        <p class="w3-col w-80pc flow-form-inline-input">
          <label class="w3-left flow-blue-color flow-padding-bottom">{{
            $t("email")
          }}</label>
          <input
            class="w3-input"
            v-bind:class="errors.emailError ? 'error' : ''"
            type="text"
            v-bind:placeholder="$t('email')"
            @blur="validateEmail"
            v-model="access.email"
          />
          <span class="w3-text-red"> {{ errors.emailError }} </span>
        </p>
      </div>

      <!-- contact phone number part -->
      <div class="w3-container flow-padding-top">
        <p class="w3-col w-80pc flow-form-inline-input">
          <label class="w3-left flow-blue-color flow-padding-bottom">{{
            $t("mobile")
          }}</label>
          <input
            class="w3-input"
            v-bind:class="errors.mobileError ? 'error' : ''"
            type="text"
            v-bind:placeholder="$t('mobile')"
            @blur="validateMobile"
            v-model="access.mobile"
          />
          <span class="w3-text-red"> {{ errors.mobileError }} </span>
        </p>
      </div>
      <div class="w3-container zero-top">
        <div class="w3-row">
          <button
            class="
              flow-btn
              w3-btn
              w3-round
              w3-border
              w3-ripple
              w3-round-medium
              w3-left
              w3-margin-right
              w3-margin-top
              w3-large
            "
            @click.prevent="save"
          >
            <i class="fa fa-save flow-green-active-color">
              <span
                ><b class="flow-margin-left">{{ $t("save") }}</b></span
              >
            </i>
          </button>
        </div>
        <div class="w3-row">
          <button
            class="
              flow-btn
              w3-btn
              w3-round
              w3-border
              w3-ripple
              w3-round-medium
              w3-left
              w3-margin-right
              w3-margin-top
              w3-large
            "
            @click.prevent="saveAndPrint"
          >
          <!-- flow-green-active-color   -->
          <!-- w3-text-blue   -->
            <i class="fa fa-print w3-text-blue">
              <span v-if="!selectedAccess.accessControlId"><b class="flow-margin-left">{{$t("saveAndPrintTicket")}}</b></span>
              <span v-else><b class="flow-margin-left">{{$t("printTicket")}}</b></span>
            </i>
          </button>
          <button
            :disabled="!access.email && !access.mobile"
            class="
              flow-btn
              w3-btn
              w3-round
              w3-border
              w3-ripple
              w3-round-medium
              w3-left
              w3-margin-right
              w3-margin-top
              w3-large
            "
            @click.prevent="saveAndSend"
          >
            <i class="fa fa-envelope w3-text-blue">
              <span v-if="!selectedAccess.accessControlId"><b class="flow-margin-left">{{$t("saveAndSendTicket")}}</b></span>
              <span v-else><b class="flow-margin-left">{{$t("sendTicket")}}</b></span>
            </i>
          </button>
        </div>
        <button
          v-if="selectedAccess.accessControlId"
          class="
            flow-btn
            w3-btn
            w3-round
            w3-border
            w3-ripple
            w3-round-medium
            w3-left
            w3-margin-right
            w3-margin-top
            w3-large
          "
          @click.prevent="endAccess"
        >
          <i class="fa fa-window-close w3-text-red">
            <span
              ><b class="flow-margin-left">{{ $t("endAccess") }}</b></span
            >
          </i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import AccessTypeBadge from "@/components/access-control/AccessTypeBadge";
const frc = Vue.prototype.$frc;
export default {
  components: {AccessTypeBadge}, props: [
    "selectedAccess",
    "preSelectedAccessType",
    "reload",
    "onClose",
    "togglePrint",
    "openNewAccess",
    "setPrintTypeAndId",
    "openAndRetrieveAccess",
    "openAndRetrieveAndPrintAccess"
  ],
  data() {
    return {
      accessControlId: "",
      access: {
        name: "",
        contact: "",
        accessType: "",
        start: this.currentDay,
        end: this.currentDay,
        patientId: "",
        email: "",
        mobile: "",
      },
      //TODO potentially delete this, not used anywhere else and a nullcheck on the errors should serve the same purpose
      validation: {
        start: true,
        end: true,
        name: true,
        email: true,
        mobile: true,
        accessType: true,
      },
      errors: {
        nameError: "",
        contactError: "",
        startError: "",
        endError: "",
        emailError: "",
        mobileError: "",
        //TODO rename this
        accessType: "",
      },
      selectValues: [],
    };
  },
  watch: {
    selectedAccess(val) {
      if (Object.keys(val).length === 0 || val === null) {
        this.resetFields();
      } else {
        this.setValues(val);
      }
      this.resetValidation();
    },
  },
  computed: {
    currentDay() {
      var date = new Date();
      var year = date.getFullYear();
      var month = date.getMonth() + 1;
      var day = date.getDate();
      return (
        day.toString().padStart(2, "0") +
        "-" +
        month.toString().padStart(2, "0") +
        "-" +
        year
      );
    },
  },
  mounted() {
    if (this.selectedAccess.accessControlId)
      this.setValues(this.selectedAccess);
    else if(this.preSelectedAccessType){
      this.access.accessType = this.preSelectedAccessType;
      this.access.start = this.currentDay;
      this.access.end = this.currentDay;
    }
  },
  methods: {
    resetValidation() {
      for (const prop in this.errors) {
        this.errors[prop] = "";
      }
      for (const prop in this.validation) {
        this.validation[prop] = true;
      }
    },
    setValues(access) {
      this.accessControlId = access.accessControlId;
      this.access.name = access.name;
      this.access.contact = access.hospitalContact;
      this.access.accessType = access.accessType;
      this.access.patientId = access.patientId;
      this.access.email = access.email;
      this.access.mobile = access.mobile;
      var splitStart = access.start.split("-");
      this.access.start =
        splitStart[2] + "-" + splitStart[1] + "-" + splitStart[0];
      var splitEnd = access.end.split("-");
      this.access.end = splitEnd[2] + "-" + splitEnd[1] + "-" + splitEnd[0];
    },
    save: function () {
      var app = this;
      if (this.validateInputFields()) {
        var newStart = app.formatStartDate(app.access.start);
        var newEnd = app.formatEndDate(app.access.end);
        var accessControlId = app.selectedAccess.accessControlId
        if (accessControlId) {
          frc
            .updateAccessControl(
              accessControlId,
              this.access.name,
              this.access.accessType,
              this.access.contact,
              this.access.patientId,
              newStart,
              newEnd,
              this.access.email,
              this.access.mobile
            )
            .then((response) => {
              app.openAndRetrieveAccess(accessControlId);
              Vue.notifySuccess({ title: app.$t("accessSuccessfullyUpdated") });
            });
        } else {
          frc
            .addNewAccessControl(
              this.access.name,
              this.access.accessType,
              this.access.contact,
              newStart,
              newEnd,
              this.access.email,
              this.access.mobile
            )
            .then((response) => {
              app.openAndRetrieveAccess(response.data);
              Vue.notifySuccess({ title: app.$t("accessSuccessfullyCreated") });
            });
        }
        this.openNewAccess();
      } else {
        Vue.notifyWarn({ title: app.$t("checkFormValues") });
      }
    },
    resetFields() {
      this.accessControlId="";
      this.access.name = "";
      this.access.contact = "";
      if(this.selectValues.length>0)
      this.access.accessType = this.selectValues[0].value;
      this.access.start = this.currentDay;
      this.access.end = this.currentDay;
      this.access.patientId = "";
      this.access.email = "";
      this.access.mobile = "";
    },
    validateInputFields() {
      this.validateName();
      this.validateStartDate();
      this.validateEndDate();
      this.validateEmail();
      this.validateMobile();
      this.validateAccessType();

      for (const prop in this.validation) {
        if (!this.validation[prop]) {
          return false;
        }
      }
      return true;
    },
    validateName() {
      var app = this;
      if (this.access.name) {
        this.validation.name = true;
        this.errors.nameError = "";
      } else {
        this.validation.name = false;
        this.errors.nameError = this.$t("pleaseEnterAValidName");
      }
    },
    validateStartDate() {
      this.errors.startError = "";
      this.validation.start = true;
      if (this.access.start) {
        var dateString = this.access.start;
        if (dateString.length === 10) {
          var splitDate = dateString.split("-");
          if (
            splitDate.length === 3 &&
            splitDate[0].length === 2 &&
            splitDate[1].length === 2 &&
            splitDate[2].length === 4
          ) {
            var month = parseInt(splitDate[1]);
            var day = parseInt(splitDate[0]);

            if (month > 12 || day > 31) {
              this.errors.startError = this.$t("date_was_not_correct");
              this.validation.start = false;
            }
            if (!this.selectedAccess.accessControlId) {
              var inputDate = new Date(this.formatStartDate(dateString));
              var tempToday = new Date();
              tempToday.setHours(0, 0, 0, 0);
              if (inputDate.getTime() < tempToday.getTime()) {
                this.errors.startError = this.$t("date_can_not_be_in_the_past");
                this.validation.start = false;
              }
            }
          } else {
            this.errors.startError = this.$t("invalid_date_format");
            this.validation.start = false;
          }
        } else {
          this.errors.startError = this.$t("invalid_date_format");
          this.validation.start = false;
        }
      } else {
        this.errors.startError = this.$t("start_date_is_required");
        this.validation.start = false;
      }
    },
    //TODO move validation of certain objects to an outside object like frc
    validateEndDate() {
      this.errors.endError = "";
      this.validation.end = true;
      if (this.access.end) {
        var dateString = this.access.end;
        if (dateString.length === 10) {
          var splitDate = dateString.split("-");
          if (
            splitDate.length === 3 &&
            splitDate[0].length === 2 &&
            splitDate[1].length === 2 &&
            splitDate[2].length === 4
          ) {
            var month = parseInt(splitDate[1]);
            var day = parseInt(splitDate[0]);

            if (month > 12 || day > 31) {
              this.errors.endError = this.$t("date_was_not_correct");
              this.validation.end = false;
            }
            if (this.selectedAccess.accessControlId) {
              var inputDate = new Date(this.formatStartDate(dateString));
              var tempToday = new Date();
              tempToday.setHours(0, 0, 0, 0);
              if (inputDate.getTime() < tempToday.getTime()) {
                this.errors.endError = this.$t("date_can_not_be_in_the_past");
                this.validation.end = false;
              }
            }
            var inputDate = new Date(this.formatEndDate(dateString));
            var tempToday = new Date(this.formatStartDate(this.access.start));
            if (inputDate.getTime() < tempToday.getTime()) {
              this.errors.endError = this.$t(
                "end_date_must_be_later_than_start_date"
              );
              this.validation.end = false;
            }
          } else {
            this.errors.endError = this.$t("invalid_date_format");
            this.validation.end = false;
          }
        } else {
          this.errors.endError = this.$t("invalid_date_format");
          this.validation.end = false;
        }
      } else {
        this.errors.endError = this.$t("end_date_is_required");
        this.validation.end = false;
      }
    },
    validateEmail() {
      var app = this;
      if (this.access.email) {
        var splitMail = this.access.email.split("@");
        if (splitMail.length === 2 && splitMail[1].includes(".")) {
          this.validation.email = true;
          this.errors.emailError = "";
        } else {
          this.validation.email = false;
          this.errors.emailError = app.$t("invalidEmail");
        }
      } else {
        this.validation.email = true;
        this.errors.emailError = "";
      }
    },
    validateMobile() {
      var app = this;
      if (this.access.mobile) {
        //TODO find a different way of handling this
        if (this.access.mobile.length > 8) {
          this.validation.mobile = true;
          this.errors.mobileError = "";
        } else {
          this.validation.mobile = false;
          this.errors.mobileError = app.$t("invalidMobileNumber");
        }
      } else {
        this.validation.mobile = true;
        this.errors.mobileError = "";
      }
    },
    validateAccessType() {
      this.errors.accessType = "";
      this.validation.accessType = true;
      if (!this.access.accessType) {
        this.errors.accessType = this.$t("accessTypeIsRequired");
        this.validation.accessType = true;
      }
    },
    formatEndDate(value) {
      var splitString = value.split("-");
      var string =
        splitString[2] +
        "-" +
        splitString[1] +
        "-" +
        splitString[0] +
        "T23:59:59";
      return string;
    },
    formatStartDate(value) {
      var splitString = value.split("-");
      return (
        splitString[2] +
        "-" +
        splitString[1] +
        "-" +
        splitString[0] +
        "T00:00:00"
      );
    },
    printTicket() {
      this.togglePrint();
    },
    sendTicket() {
      var app = this;
      frc
        .sendQRCodeForAccessControl(this.selectedAccess.accessControlId)
        .then(() => {
          Vue.notifySuccess({ title: app.$t("ticketSuccessFullySent") });
        });
    },
    endAccess() {
      var app = this;
      frc
        .terminateAccessControl(this.selectedAccess.accessControlId)
        .then((response) => {
          app.reload();
          app.onClose();
          Vue.notifySuccess({ title: app.$t("accessSuccessfullyTerminated") });
        });
    },
    saveAndPrint() {
      var app = this;
      if (this.validateInputFields()) {
        var newStart = app.formatStartDate(app.access.start);
        var newEnd = app.formatEndDate(app.access.end);
        //This value is required because the fields reset before the call happens sometimes therefor sending undefineds.
        var usedAccessType = app.access.accessType;
        if (this.selectedAccess.accessControlId) {
          //This value is required because the fields reset before the call happens sometimes therefor sending undefineds.
          var usedAccessControlId = app.selectedAccess.accessControlId;
          frc.updateAccessControl(
              this.selectedAccess.accessControlId,
              this.access.name,
              this.access.accessType,
              this.access.contact,
              this.access.patientId,
              newStart,
              newEnd,
              this.access.email,
              this.access.mobile
            )
            .then((response) => {
              Vue.notifySuccess({ title: app.$t("accessSuccessfullyUpdated") });
              app.openAndRetrieveAndPrintAccess(usedAccessControlId);
              //app.openAndRetrieveAccess(usedAccessControlId);
              //app.setPrintTypeAndId(usedAccessType,usedAccessControlId);
            });
        } else {
          frc.addNewAccessControl(
              this.access.name,
              this.access.accessType,
              this.access.contact,
              newStart,
              newEnd,
              this.access.email,
              this.access.mobile
            )
            .then((response) => {
              Vue.notifySuccess({ title: app.$t("accessSuccessfullyCreated") });
              app.openAndRetrieveAndPrintAccess(response.data);
              //app.openAndRetrieveAndPrintAccess(response.data);
              //app.setPrintTypeAndId(usedAccessType,response.data);
            });
        }
      }
    },
    saveAndSend() {
      var app = this;
      if (this.validateInputFields()) {
        var newStart = app.formatStartDate(app.access.start);
        var newEnd = app.formatEndDate(app.access.end);

        if (this.selectedAccess.accessControlId) {
          var usedAccessControlId = app.selectedAccess.accessControlId;
          frc
            .updateAccessControl(
              this.selectedAccess.accessControlId,
              this.access.name,
              this.access.accessType,
              this.access.contact,
              this.access.patientId,
              newStart,
              newEnd,
              this.access.email,
              this.access.mobile
            )
            .then((response) => {
              Vue.notifySuccess({ title: app.$t("accessSuccessfullyUpdated") });
              frc.sendQRCodeForAccessControl(usedAccessControlId).then(() => {
                Vue.notifySuccess({ title: app.$t("ticketSuccessFullySent") });
                app.openAndRetrieveAccess(usedAccessControlId);
              });
            });
        } else {
          frc
            .addNewAccessControl(
              this.access.name,
              this.access.accessType,
              this.access.contact,
              newStart,
              newEnd,
              this.access.email,
              this.access.mobile
            )
            .then((response) => {
              Vue.notifySuccess({ title: app.$t("accessSuccessfullyUpdated") });
              frc.sendQRCodeForAccessControl(response.data).then(() => {
                Vue.notifySuccess({ title: app.$t("ticketSuccessFullySent") });
                app.openAndRetrieveAccess(response.data);
              });
            });
        }
      }
    }
  },
};
</script>

<style scoped>
select {
  margin-top: 6px;
  width: 92%;
}
</style>